function c(t) {
  return (e) => {
    if (!e)
      t(e);
    else if (typeof e == "function")
      t(e);
    else if (typeof e == "object" && "nativeEvent" in e) {
      const { currentTarget: n } = e;
      n instanceof HTMLInputElement ? n.type === "checkbox" ? t(n.checked) : t(n.value) : (n instanceof HTMLTextAreaElement || n instanceof HTMLSelectElement) && t(n.value);
    } else
      t(e);
  };
}
export {
  c as getInputOnChange
};
